// История просмотра материалов — только в браузере посетителя (localStorage): без входа, без сервера.
// Плеер ВК не сообщает, до какого места дошёл зритель, поэтому запоминаем последний открытый материал
// и последний выбранный пункт «Содержания» — с него и предлагаем продолжить.
const KEY = "sv_watch_history_v1";
const MAX = 20;

export function readHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter(x => x && x.id) : [];
  } catch (e) {
    return [];
  }
}

function write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* приватный режим и т.п. — не критично */ }
}

/** Материал открыт: поднимаем его в начало списка, сохраняя ранее выбранную позицию. */
export function recordWatch(lecture) {
  if (!lecture || !lecture.id) return;
  const all = readHistory();
  const prev = all.find(x => x.id === lecture.id);
  write([{
    id: lecture.id, title: lecture.title, thumbnail_url: lecture.thumbnail_url || null,
    duration: lecture.duration || null, author: lecture.author || null,
    pos: prev?.pos || 0, chapter: prev?.chapter || null, at: Date.now(),
  }, ...all.filter(x => x.id !== lecture.id)]);
}

/** Зритель выбрал пункт «Содержания»: запоминаем секунду и название. */
export function setPosition(id, pos, chapter) {
  const all = readHistory();
  write(all.map(x => (x.id === id ? { ...x, pos, chapter, at: Date.now() } : x)));
}

export function clearHistory() {
  try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
}

export function formatPos(sec) {
  const s = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  const mm = String(m).padStart(h ? 2 : 1, "0"), ss = String(r).padStart(2, "0");
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
